import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=53d7165e&scoped=true"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=53d7165e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d7165e",
  null
  
)

export default component.exports